<template>
  <div class="contain">
    <div class="title">基础用法</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="sliderVerify('basic')"
        ><span class="text">滑块验证</span></van-button
      >
    </div>
    <div class="title">滑块样式</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="sliderVerify('basic')"
        ><span class="text">弹出式滑块 popup</span></van-button
      >
    </div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="sliderVerify('embed')"
        ><span class="text">嵌入式滑块 embed</span></van-button
      >
    </div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="sliderVerify('inlineUp')"
        ><span class="text">内联式滑块 inline (向上浮出)</span></van-button
      >
    </div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="sliderVerify('inlineDown')"
        ><span class="text">内联式滑块 inline (向下浮出)</span></van-button
      >
    </div>
    <div class="title">滑块失败回调函数</div>
    <div class="wrapper top">
      <van-button type="info" :round="showRound" @click="sliderVerify('fail')"
        ><span class="text">滑块验证</span></van-button
      >
    </div>
    <div class="title">滑块拖拽文案</div>
    <div class="wrapper top">
      <van-button
        type="info"
        :round="showRound"
        @click="sliderVerify('dragWriting')"
        ><span class="text">滑块验证</span></van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'CaptchaDemo',
  components: {},
  data() {
    return {
      showRound: true,
      rootStyle: {}, // 嵌入式和内联式滑块的样式
      inlineFloatPosition: 'up', // 仅当 slideStyle 为 inline 时有效
    }
  },
  mounted() {},
  methods: {
    sliderVerify(val) {
      let params
      if (val == 'basic') {
        params = {}
      } else if (val == 'embed') {
        this.rootStyle = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }
        params = {
          slideStyle: 'embed',
          rootStyle: this.rootStyle,
        }
      } else if (val == 'inlineUp') {
        this.rootStyle = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }
        params = {
          slideStyle: 'inline',
          rootStyle: this.rootStyle,
          inlineFloatPosition: 'up',
        }
      } else if (val == 'inlineDown') {
        this.rootStyle = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%,-50%)',
        }
        params = {
          slideStyle: 'inline',
          rootStyle: this.rootStyle,
          inlineFloatPosition: 'down',
        }
      } else if (val == 'fail') {
        let failCb = function (failObj, context) {
          console.log('context:', context.successText)
          alert(failObj.message)
          if (failObj.message === '请求超时') {
            context.reject(failObj)
            context.remove()
          }
        }
        params = {
          failCb: failCb,
        }
      } else if (val == 'dragWriting') {
        params = {
          slideText: '向右向右',
        }
      }
      this.$mxCaptcha
        .showCaptcha(params)
        .then((res) => {
          console.log('showCaptcha-res:', res)
        })
        .catch((err) => {
          console.log('showCaptcha-err:', err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.contain {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 40px;
  .title {
    padding-top: 40px;
    margin-left: 20px;
    font-size: 14px;
    color: rgba(69, 90, 100, 0.6);
  }
  .top {
    margin-top: 15px;
  }
  .wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .height {
    height: 300px;
  }
}
.van-button--info {
  width: 90%;
  height: 44px;
  color: #000000;
  background-color: #ffffff;
  border: none;
  border-radius: 8px;
}
</style>
